import React, { Component } from 'react'

// Components
import Select from 'react-select'
import 'react-select/dist/react-select.css'

class YearDropdown extends Component {
    constructor(props){
        super(props)
        this.state = {
            years: [],
            defaultYear: new Date().getFullYear()
        }

        // If years collection were given
        if(props.years){
            this.state = {
                ...this.state,
                years: props.years
            }
        
        // Default year collection (10 years)
        }else{
            let years = []
            for(let i = 0; i < 10; i++){
                const newYear = this.state.defaultYear + i
                years.push({
                    value: newYear,
                    label: newYear
                })
            }

            this.state = {
                ...this.state,
                years: years
            }
        }

        // If default year was given
        if(props.defaultYear){
            this.state = {
                ...this.state,
                defaultYear: props.defaultYear
            }
        }
    }

    updateSelection = (selection) => {
        this.props.handleChange(selection)
    }

    render() {
        let { year = '' } = this.props
        // if(year === '') year = this.updateSelection(this.state.defaultYear)

        return (
            <Select
                name={`year`}
                placeholder='Select Year'
                value={year}
                onChange={(selection) => this.updateSelection(selection.value)}
                clearable={false}
                options={this.state.years}
            />
        )
    }
}

export default YearDropdown



// WEBPACK FOOTER //
// ./src/components/YearDropdown.js